import Page from "../../../layout/Page/Page";
import PageWrapper from "../../../layout/PageWrapper/PageWrapper";
import { CommonExpiringWorkResourceList } from "./Common/CommonExpiringWorkResourceList";

const ExpiringWorkResourcePage = () => {
	return (
		<PageWrapper title='Vencimento de Ferramentas e EPI'>
			<Page container='fluid'>
				<div className='row'>
					<div className='col-12'>
						<CommonExpiringWorkResourceList />
					</div>
				</div>
			</Page>
		</PageWrapper>
	);
};

export default ExpiringWorkResourcePage;